import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { AgGridReact } from "ag-grid-react"; // React Grid Logic
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { FaRegEdit } from "react-icons/fa";
import { Text } from "components";
import { Link } from "react-router-dom";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const WorkStationOperationList = forwardRef((props, ref) => {
  const [operationWorkstation, setoperationWorkstation] = useState([]);
  console.log(props.id);

  const gridRef = useRef();
  const data = useRef([]);
  const navigate = useNavigate();
  const [download, setDownload] = useState(false);

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const [erplist, setErplist] = useState([]);

  useEffect(() => {
    // Retrieving data from sessionStorage
    const storedErplist = sessionStorage.getItem("erplist");

    if (storedErplist) {
      try {
        // Parsing the JSON string to an array of objects
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);
  // console.log(erplist);
  const showActionColumn = erplist.some(
    (item) => item.erp_module_id == 44 && item.update
  );

  useEffect(() => {
    getAllOperations();
  }, []);

  let checkdata = null;

  const getAllOperations = () => {
    axios
      .post(
        "/api/purple-fusion/operationworkstation/get",
        { operation_id: props.id },
        headers
      )
      .then((response) => {
        console.log(response.data);
        if (response.data.length < 1) {
          // document.getElementById("progrss-bar-id").style.visibility = "hidden";
          document.getElementById("progress-bar-id").innerHTML =
            "No record found.";
        } else {
          setoperationWorkstation(
            response.data.slice().sort((a, b) => b.id - a.id)
          );
          console.log(response.data);

          checkdata = response.data;
          data.current = response.data.slice().sort((a, b) => b.id - a.id);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useImperativeHandle(
    ref,
    () => ({
      downloadExcel: () => {
        onBtnExport();
      },

      downloadPdf: () => {
        DownloadPDF();
      },
    }),
    []
  );

  const DownloadPDF = () => {
    const data = props.id
      ? JSON.parse(localStorage.getItem("data")).filter(
          (data) => data.workstation_id == props.id
        )
      : JSON.parse(localStorage.getItem("data"));
    const docDefinition = {
      pageOrientation: "portrait",
      header: {
        text: "Operation Workstations",
        style: "header",
      },
      content: [
        {
          style: "tableExample",
          table: {
            body: [
              [
                [{ text: "SNO.", style: "tableHeader", bold: true }],
                [{ text: "OPERATION NAME", style: "tableHeader", bold: true }],
                [
                  {
                    text: "WORKSTATION NAME",
                    style: "tableHeader",
                    bold: true,
                  },
                ],
                [{ text: "DEFAULT", style: "tableHeader", bold: true }],
                [{ text: "CREATED DATE", style: "tableHeader", bold: true }],
                [{ text: "ACTIVE", style: "tableHeader", bold: true }],
              ],
              ...data.map((operationWorkstation, index) => [
                // operationWorkstation.id,
                index + 1,
                operationWorkstation.operationname,
                operationWorkstation.workstationname,
                operationWorkstation.isdefault ? "Yes" : "No",
                operationWorkstation.createdon.substr(0, 10),
                operationWorkstation.isactive ? "Yes" : "No",
              ]),
            ],
            widths: "auto",
          },
          layout: {
            fillColor: function (rowIndex, node, columnIndex) {
              return rowIndex === 0 ? "#CCCCCC" : null;
            },
          },
        },
      ],
      styles: {
        tableExample: {
          fontSize: 8, // Set the font size to a smaller value
          color: "#333",
        },
        tableHeader: {
          bold: true,
          fontSize: 10, // You can set a different font size for headers if needed
          color: "#000",
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [10, 10, 10, 20],
          // Add underline
          color: "#333",
        },
      },
    };
    pdfMake.createPdf(docDefinition).download("operation workstation");
  };

  const onBtnExport = useCallback(() => {
    const columnsToExport = [
      "sr",
      "operationname",
      "workstationname",
      "isdefault",
      "createdon",
      "isactive",
    ]; // Replace with your actual column field

    const exportColumns = customColDefs.filter((column) =>
      columnsToExport.includes(column.field)
    );
    const options = {
      fileName: "Operation workstation List.csv", // Specify your desired filename here
      columnKeys: exportColumns.map((column) => column.field), // Specify the column field to export
    };
    gridRef.current.api.exportDataAsCsv(options);
  }, []);

  const defaultColDefs = [
    { headerName: "SNO.", field: "sr", width: 100 },
    {
      headerName: "OPERATION NAME",
      field: "operationname",
      width: 220,
    },
    {
      headerName: "WORKSTATION NAME",
      field: "workstationname",
      width: 220,
    },
    {
      headerName: "DEFAULT",
      field: "isdefault",
      minWidth: 100,
      maxWidth: 180,
      valueFormatter: (params) => {
        return params.value ? "Yes" : "No";
      },
    },
    {
      headerName: "ACTIVE",
      field: "isactive",
      minWidth: 100,
      maxWidth: 180,
      valueFormatter: (params) => {
        return params.value ? "Yes" : "No";
      },
    },
    {
      headerName: "CREATED DATE",
      field: "createdon",
      valueFormatter: (params) => {
        return params.value.substr(0, 10);
      },
      minWidth: 120,
      maxWidth: 250,
    },
  ];

  const customColDefs = [
    ...defaultColDefs,
    // {
    //   headerName: "",
    //   pinned: "right",
    //   field: "id",
    //   cellRenderer: (params) => (
    //     <button
    //       className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
    //       onClick={() => {
    //         if (!props.id) {
    //           navigate(`/operationworkstation/edit/${params.value}`);
    //         }

    //         navigate(`/operationworkstation/edit/${params.value}`, {
    //           state: {
    //             id: props.id,
    //             OW_name: props.OW_name,
    //             operationname: params.data.operationname,
    //             workstationname: params.data.workstationname,
    //           },
    //         });
    //       }}
    //     >
    //       <FaRegEdit />
    //     </button>
    //   ),
    //   width: 50,
    //   filter: false,
    // },
  ];

  const [colDefs, setColDefs] = useState([]);
  useEffect(() => {
    setColDefs(showActionColumn ? customColDefs : defaultColDefs);
  }, [showActionColumn]);

  const ColDefaultVale = { filter: true };

  const gridOptions = {
    overlayNoRowsTemplate: `
        <div id="progress-bar-id" class="flex items-center justify-center">
            <div class="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500"></div>
        </div>
    `,
  };

  return (
    <>
      {erplist.some((item) => item.erp_module_id === 44 && item.view) ? (
        <div className="overflow-hidden">
          {!props.id && (
            <div className="flex p-4 flex-row w-full items-center">
              <Text
                className="text-2xl md:text-[22px] whitespace-nowrap text-gray-800 sm:text-xl tracking-[0.20px] w-[85px]"
                size="txtInterSemiBold24"
              >
                {" "}
                Operation WorkStation
              </Text>
              <div className="flex text-3xl relative flex-row justify-end items-center font-inter gap-2 px-[10px] w-full leading-none tracking-tight text-gray-900 md:text-4xl lg:text-5xl dark:text-white">
                <div className="flex flex-col relative">
                  <button
                    onClick={() => setDownload(!download)}
                    id="dropdownDefaultButton"
                    data-dropdown-toggle="dropdown"
                    className="text-white-A700 bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                    type="button"
                  >
                    {"Download"} &nbsp;{" "}
                    <svg
                      class="w-2.5 h-2.5 ms-3"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 10 6"
                    >
                      <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="m1 1 4 4 4-4"
                      />
                    </svg>
                  </button>
                  <div
                    className={`${
                      download ? "absolute top-[45px]" : "hidden"
                    } z-20 bg-white divide-y divide-gray-100 rounded-lg shadow w-[125px] bg-white-A700  dark:bg-gray-700`}
                  >
                    <ul
                      class="py-2 text-sm text-gray-700 dark:text-gray-200"
                      aria-labelledby="dropdownDefaultButton"
                    >
                      <li>
                        <span
                          className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                          onClick={DownloadPDF}
                        >
                          PDF
                        </span>
                      </li>
                      <li>
                        <span
                          className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                          onClick={onBtnExport}
                        >
                          Excel
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                {erplist.some(
                  (item) => item.erp_module_id === 44 && item.add
                ) && (
                  <Link to={`/operationworkstation/add`}>
                    <div className="flex flex-col items-center justify-center">
                      <button
                        type="button"
                        id="dropdownDefaultButton"
                        className="text-white-A700 bg-blue-700  hover:bg-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 "
                      >
                        + Add
                      </button>
                    </div>
                  </Link>
                )}
              </div>
            </div>
          )}
          <div
            className="ag-theme-quartz relative overflow-scroll"
            // style={{ height: 550,width:"100%",fontSize:"12px" }}
            id="tab-grid-table"
          >
            <AgGridReact
              ref={gridRef}
              rowData={operationWorkstation.map(
                (OperationWorkstation, index) => ({
                  ...OperationWorkstation,
                  sr: index + 1,
                })
              )}
              columnDefs={colDefs}
              pagination={true}
              defaultColDef={ColDefaultVale}
              suppressMenuHide={true}
              suppressExcelExport={true}
              gridOptions={gridOptions}
            />
          </div>
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <div className="text-4xl text-red-500">No Access</div>
        </div>
      )}
    </>
  );
});

export default WorkStationOperationList;
